import { ErrorService } from "../services/error-service/error.service";
import { InterCopmonentDataCarrierService } from "../services/inter-copmonent-data-carrier-service/inter-copmonent-data-carrier.service";
import { MyHttpService } from "../services/myHttp/my-http.service";
import { SettingsService } from "../services/settings/settings.service";
import { UserService } from "../services/user/user-service/user.service";

export const commonProviders: Array<any> = [
    ErrorService,
    InterCopmonentDataCarrierService,
    UserService,
    MyHttpService,
    SettingsService,
]